import LogicaAPI from "./logicaapi";
class HtmlSnippet extends LogicaAPI {
  async getHtmlSnippet(id, idKey) {
    const idOrIdKey = id || idKey;
    return this.get(`/api/v1/html_snippets/${idOrIdKey}`);
  }
}
export default HtmlSnippet;